var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.isWorkspaceMember
        ? _c("PortfolioNavigation", {
            attrs: {
              workspaceId: _vm.workspaceId,
              projectId: _vm.tchProjectId,
            },
          })
        : _vm.isProjectOwner
        ? _c("Navigation")
        : _vm._e(),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v(_vm._s(_vm.rm.ProjectName))]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _vm.pnlTemplates
                      ? _c("div", { staticClass: "btn-group" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-success dropdown-toggle",
                              staticStyle: { padding: "0.7em 2em" },
                              attrs: {
                                type: "button",
                                "data-toggle": "dropdown",
                              },
                            },
                            [_vm._v("P&L: " + _vm._s(_vm.selectedPnl.Name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu dropdown-menu-right",
                            },
                            _vm._l(_vm.pnlTemplates, function (t) {
                              return _c(
                                "a",
                                {
                                  key: t.Id,
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.switchPnlTemplate(t.Id)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(t.Name))]
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "sanitizedHref",
                            rawName: "v-sanitizedHref",
                            value: `/#/portfolio/alternative/dashboard/${_vm.rm.WorkspaceId}/${_vm.rm.TchProjectId}/${_vm.rm.ProjectId}`,
                            expression:
                              "`/#/portfolio/alternative/dashboard/${rm.WorkspaceId}/${rm.TchProjectId}/${rm.ProjectId}`",
                          },
                        ],
                        staticClass: "btn btn-outline-secondary",
                        staticStyle: { padding: "0.7em 2em" },
                      },
                      [_vm._v("Meta data")]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("ProjectNavigation", {
                staticClass: "mt-4 mb-4",
                attrs: {
                  ActivePage: "pnl",
                  workspaceId: _vm.workspaceId,
                  tchProjectId: _vm.tchProjectId,
                  projectId: _vm.projectId,
                  planId: _vm.rm.ProjectPlanId,
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mb-3" }, [
                _c(
                  "button",
                  {
                    class: _vm.cagrVisible
                      ? "btn btn-info"
                      : "btn btn-outline-secondary",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.toggleCagrVisible()
                      },
                    },
                  },
                  [
                    _c("i", {
                      class: _vm.cagrVisible
                        ? "fa-regular fa-square-check"
                        : "fa-regular fa-square",
                    }),
                    _vm._v("\n                CAGR\n            "),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "btn-group" }, [
                  _c(
                    "button",
                    {
                      class: _vm.applyBenefitsConfidenceFactor
                        ? "btn btn-danger"
                        : "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleBenefitsConfidenceFactor()
                        },
                      },
                    },
                    [
                      _c("i", {
                        class: _vm.applyBenefitsConfidenceFactor
                          ? "fa-regular fa-square-check"
                          : "fa-regular fa-square",
                      }),
                      _vm._v(
                        "\n                    Risk adjusted benefits (" +
                          _vm._s(_vm.benefitsConfidenceFactorLabel) +
                          ")\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu dropdown-menu-right p-2",
                      staticStyle: { width: "100%" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c(
                        "form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.handleUpdateBenefitsConfidenceFactorCommand.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [
                              _vm._v("Benefits confidence factor (0-100):"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.benefitsConfidenceFactorInput,
                                  expression: "benefitsConfidenceFactorInput",
                                  modifiers: { number: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "number",
                                placeholder: "100",
                                min: "0",
                                max: "100",
                                step: "0.1",
                                disabled:
                                  _vm.savingBenefitsConfidenceFactorInput,
                              },
                              domProps: {
                                value: _vm.benefitsConfidenceFactorInput,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.benefitsConfidenceFactorInput = _vm._n(
                                    $event.target.value
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                type: "submit",
                                disabled:
                                  _vm.savingBenefitsConfidenceFactorInput,
                              },
                            },
                            [_vm._v("Update")]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "btn-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary dropdown-toggle",
                      attrs: { type: "button", "data-toggle": "dropdown" },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.rm.Denomination) +
                          "s\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-menu" }, [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            return _vm.setDenomination("Million")
                          },
                        },
                      },
                      [_vm._v("Millions")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            return _vm.setDenomination("Thousand")
                          },
                        },
                      },
                      [_vm._v("Thousands")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            return _vm.setDenomination("Unit")
                          },
                        },
                      },
                      [_vm._v("Units")]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("PnlViewer", {
                attrs: {
                  readModel: _vm.rm.Report,
                  cagrVisible: _vm.cagrVisible,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass:
          "btn btn-outline-secondary dropdown-toggle-split rounded-right",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-expanded": "false",
        },
      },
      [
        _c("i", { staticClass: "fa fa-pencil" }),
        _vm._v(" "),
        _c("span", { staticClass: "sr-only" }, [_vm._v("Toggle Dropdown")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }